import { createContext, FC, useContext, useRef, useState } from "react";
import { REPORT_FILTER_BY_OPTION_VALUES } from "../constants";

const contextDefaultValue = {
  allGroupsSelected: false,
  setAllGroupsSelected: (allGroupsSelected: any) => {},
  selectedGroups: [] as string[],
  allCamerasSelected: false,
  setAllCamerasSelected: (allCamerasSelected: any) => {},
  groupSearchKeyword: "",
  setGroupSearchKeyword: (groupSearchKeyword: string) => {},
  cameraSearchKeyword: "",
  setCameraSearchKeyword: (cameraSearchKeyword: string) => {},
  selectedCameras: [] as string[],
  selectedDataType: REPORT_FILTER_BY_OPTION_VALUES.CAMERA,
  setSelectedDataType: (selectedDataType: any) => {},
  setSelectedGroups: (selectedGroups: string[]) => {},
  setSelectedCameras: (selectedCameras: string[]) => {},
  onGroupSelectionConfirm: null as any,
};

const cameraAdminContext = createContext(contextDefaultValue);

export const CameraAdminContextProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [allGroupsSelected, setAllGroupsSelected] = useState(true);
  const [allCamerasSelected, setAllCamerasSelected] = useState(true);
  const [groupSearchKeyword, setGroupSearchKeyword] = useState("");
  const [cameraSearchKeyword, setCameraSearchKeyword] = useState("");
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const [selectedCameras, setSelectedCameras] = useState<string[]>([]);
  const [selectedDataType, setSelectedDataType] = useState(
    REPORT_FILTER_BY_OPTION_VALUES.CAMERA
  );
  const onGroupSelectionConfirm = useRef((values: any) => {});

  return (
    <cameraAdminContext.Provider
      value={{
        allGroupsSelected,
        setAllGroupsSelected,
        selectedGroups,
        setSelectedGroups,
        setSelectedCameras,
        onGroupSelectionConfirm,
        allCamerasSelected,
        setAllCamerasSelected,
        groupSearchKeyword,
        setGroupSearchKeyword,
        cameraSearchKeyword,
        setCameraSearchKeyword,
        selectedCameras,
        setSelectedDataType,
        selectedDataType,
      }}
    >
      {children}
    </cameraAdminContext.Provider>
  );
};

export const useCameraAdminContext = () => {
  const {
    allGroupsSelected,
    setAllGroupsSelected,
    selectedGroups,
    allCamerasSelected,
    setAllCamerasSelected,
    groupSearchKeyword,
    setGroupSearchKeyword,
    cameraSearchKeyword,
    setCameraSearchKeyword,
    selectedCameras,
    setSelectedDataType,
    selectedDataType,
    setSelectedGroups,
    setSelectedCameras,
  } = useContext(cameraAdminContext);
  return {
    allGroupsSelected,
    setAllGroupsSelected,
    selectedGroups,
    allCamerasSelected,
    setAllCamerasSelected,
    groupSearchKeyword,
    setGroupSearchKeyword,
    cameraSearchKeyword,
    setCameraSearchKeyword,
    selectedCameras,
    setSelectedDataType,
    selectedDataType,
    setSelectedGroups,
    setSelectedCameras,
  };
};
